// extracted by mini-css-extract-plugin
module.exports = {"root":"Note_root__kUHNx","info":"Note_info__1L4IN","note":"Note_note__kLVdm","actions":"Note_actions__26rHi"};